import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FinanceService } from 'src/app/finance/finance.service';
import { InventoryJournalReport } from './models/inventoryGL.response.mode';
import { ImpactsOnGlColumns } from 'src/app/inventory/sales-order/constants/constants';
import { MessageService } from 'primeng/api';
import { Severity } from 'src/app/inventory/constants/constants';
import { TitleCasePipe } from '@angular/common';
import { ImportserialService } from '../../services/importserial.service';

@Component({
  selector: 'app-inventory-impacts-gl',
  templateUrl: './inventory-impacts-gl.component.html',
  styleUrl: './inventory-impacts-gl.component.scss'
})
export class InventoryImpactsGlComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectedId: number;
  @Input() objectTypeId: number;
  @Input() callApi: boolean;
  @Input() impacts: any;
  @Input() totalDebit: number = 0;
  @Input() totalCredit: number = 0;
  private destroy$ = new Subject<void>();

  impactsOnGlColumns = ImpactsOnGlColumns;
  fractionDigits: number = 0;

  constructor(
    private financeService: FinanceService,
    private messageService: MessageService,
    private titlecasePipe: TitleCasePipe,
    private importService: ImportserialService
  ) { }

  ngOnInit(): void {
    this.getFractionDigits();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getAllJournal();
  }

  getAllJournal() {
    if (this.selectedId == null || this.objectTypeId == null || this.callApi == false) {
      return;
    }
    this.financeService.getInventoryJournalReport(this.selectedId, this.objectTypeId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.impacts = res;
          if (this.impacts.length > 0) {
            const firstRecord = this.impacts[0];
            this.totalDebit = firstRecord.totalDebit;
            this.totalCredit = firstRecord.totalCredit;
          }
          else {
            this.totalCredit = 0;
            this.totalDebit = 0;
          }
        },
        error: (error) => {
          this.messageService.add({
            severity: Severity.Error,
            summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Error occurred fetching impacts journal.",
          })
        }
      })
  }

  getFractionDigits() {
    this.importService
      .getDecimalValue()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value) => {
          if (value) {
            this.fractionDigits = value;
          }
        },
        error: (error) => { },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
